import { cardeal } from './api';

export class PercentualRecebimentoRendaService {
  getRecebimentoSaldoContas = async (matricula, plano) => {
    const response = await cardeal.get(
      'ObterPercentualSaldoContaParticipante',
      {
        params: {
          matricula,
          plano,
        },
      }
    );
    return response.data.ObterPercentualSaldoContaParticipanteResult.Value;
  };

  getHistoricoIntencaoMudancaRecebimentoParticipante = async (
    matricula,
    plano
  ) => {
    const response = await cardeal.get(
      'ObterHistoricoIntencaoMudancaRecebimentoParticipante',
      {
        params: {
          matricula,
          plano,
        },
      }
    );
    return response.data;
  };

  getLimitePercentualCotasMensal = async (matricula, plano) => {
    const response = await cardeal.get('ObterLimitePercentualCotasMensal', {
      params: {
        matricula,
        plano,
      },
    });
    return response.data.ObterLimitePercentualCotasMensalResult;
  };

  getValorBeneficioParticipante = async (matricula, plano) => {
    const response = await cardeal.get('ObterValorBeneficioParticipante', {
      params: {
        matricula,
        plano,
      },
    });
    return response.data.ObterValorBeneficioParticipanteResult.Value;
  };

  getSaldoRemanescenteParticipante = async (matricula) => {
    const response = await cardeal.get('ObterSaldoRemanescenteParticipante', {
      params: {
        matricula,
      },
    });
    if (response.data.ObterSaldoRemanescenteParticipanteResult.Error) {
      return 0;
    }

    return response.data.ObterSaldoRemanescenteParticipanteResult.Value;
  };

  setTrocaPercentualRecebimentoRendaParticipanteSaldoConta = async (
    matricula,
    percentualVigente,
    percentualNovo,
    valorSaldoRemanescente
  ) => {
    const response = await cardeal.post(
      'RegistrarIntencaoTrocaPercentualRecebimentoRendaParticipanteSaldoConta',
      {
        matricula,
        percentualVigente,
        percentualNovo,
        valorSaldoRemanescente,
      }
    );
    return response.data
      .RegistrarIntencaoTrocaPercentualRecebimentoRendaParticipanteResult;
  };
}
